import apiClient from "../../utils/apiclient";

export const getTasksToApprove = async (
token: string, status: string, search: string, page: string, limit: string, locations: string[], task_id: string[]) => {

   const query = `/admin/task/get-task-to-approve-v1?status=${status}&search=${search}&page=${page}&limit=${limit}&locations=${locations}&task_id=${task_id}`;
 
   return await apiClient.get(query, {
     headers: {
       Authorization: `Bearer ${token}`,
     },
   });
 };



 

 export const getdropdowncities=async()=>{
   return await apiClient.get('city/distinctcity',{
     
   })
}



export const getdropdowntaskname=async()=>{
  return await apiClient.get('/admin/task/get_taskname_dropname',{
    
  })
}


 
 


export const taskApproveOrRejcet=async(reqBody:{
    accountId: string;
    task_id: string,
    status: 'approved'|'rejected',
    remarks:null|string
},token:string)=>{
   return await apiClient.post('/admin/task/update-approval-status',reqBody,{
      headers:{
         Authorization: `Bearer ${token}`
      }
   })

   
}


export const reassigntask=async(reqBody:{
  publish_id: string;
},token:string)=>{
 return await apiClient.post('/admin/task/reassign_task',reqBody,{
    headers:{
       Authorization: `Bearer ${token}`
    }
 })

 
}


export const getdrawedetails=async(reqBody:{
   usertaskid: any;
 },token:string)=>{
  return await apiClient.post('/admin/task/get_questions_details',reqBody,{
     headers:{
        Authorization: `Bearer ${token}`
     }
  })
 
  
 }


export const verifeidbypmi=async(reqBody:{
   user_task_mapping_id: string;
},token:string)=>{
  return await apiClient.post('/admin/task/udate_verifiedby_pmi',reqBody,{
     headers:{
        Authorization: `Bearer ${token}`
     }
  })

  
}

export const rejectedquestions=async(reqBody:{
   usertaskid: any;
 },token:string)=>{
  return await apiClient.post('/admin/task/get_rejectedquestions',reqBody,{
     headers:{
        Authorization: `Bearer ${token}`
     }
  })
}